var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgActivityCheck = function SvgActivityCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.562 3.098a.475.475 0 0 1 .184.314.466.466 0 0 1-.096.35L5.511 8.815a.479.479 0 0 1-.35.184.488.488 0 0 1-.371-.138L2.385 6.496a.469.469 0 0 1 .006-.664.485.485 0 0 1 .674-.005L5.083 7.81l3.804-4.626a.479.479 0 0 1 .32-.181.489.489 0 0 1 .355.094Z",
    fill: "#fff"
  })));
};
export default SvgActivityCheck;